import { Box, Stack, Typography } from '@mui/material'
import { VesselServiceResponseDto } from '@planning/app/api'
import { usePlanningStore } from '@planning/AppProvider'
import { useTranslate } from '@tolgee/react'
import { TomAutoComplete } from '@tom-ui/ui'
import _ from 'lodash'
import { computed } from 'mobx'
import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'

interface IProps {
  label?: string
  value?: number | null
  hasError?: boolean
  onChange: (vesselId?: number) => void
  required?: boolean
  validate?: () => void
}

const filterOptions = (
  options: VesselServiceResponseDto[],
  { inputValue }: { inputValue: string },
) => {
  if (!inputValue || inputValue.trim() === '') return []

  const inputValueLower = inputValue.toLowerCase()
  return options.filter(option => {
    return (
      option.name.toLowerCase().includes(inputValueLower) ||
      option.serviceId.toLowerCase().includes(inputValueLower)
    )
  })
}

export const VesselServiceAutocomplete = observer(
  ({ hasError, label, value, onChange, required, validate }: IProps) => {
    const { t } = useTranslate()

    const { vesselServiceItemStore } = usePlanningStore()

    useEffect(() => {
      vesselServiceItemStore.fetch()
    }, [vesselServiceItemStore])

    const [filter, setFilter] = useState<string>('')

    const options = computed(() =>
      _.values(vesselServiceItemStore.elements).map(vesselService => vesselService.data),
    ).get()

    return (
      <>
        <TomAutoComplete
          dataCy='vessel-service-autocomplete'
          label={label ?? t('service', 'Service')}
          required={required}
          entityKey='id'
          entityDisplayValue={'name'}
          options={options}
          validate={validate}
          defaultValue={options.find(x => x?.id === value) ?? undefined}
          onChangeEntity={entity => {
            if (!entity) {
              setFilter('')
            }

            onChange?.(entity?.id)
          }}
          onChangeFilter={filter => {
            if (!filter) {
              setFilter('')
              return
            }

            setFilter(filter)
          }}
          error={hasError}
          helperText={hasError ? t('fieldIsRequired', 'Field is required') : undefined}
          renderOption={(props, option) => (
            <Box component={'li'} {...props}>
              <Stack
                flexDirection='row'
                width='100%'
                justifyContent='space-between'
                alignItems='center'
              >
                <Typography>{option.name}</Typography>
                <Typography>{option?.serviceId ?? ''}</Typography>
              </Stack>
            </Box>
          )}
          filterOptions={filterOptions}
        />
      </>
    )
  },
)
